function resetLoaderToMenu(target) {
    if(!$('#drilldown-menu').find('.menu_loader').is('.menu_loader')) {
        $('#drilldown-menu').html('<div class="menu_loader" style="text-align: center; padding-top: 100px;"><img src="https://' + window.location.host.replace("www.","cdn.") + '/assets/img/loading-product-zwart.svg" width="45" height="45" /></div>');
    }
};

var fncUpdateSlinky = function(target) {
    resetLoaderToMenu(target);

    setTimeout(function() {
        fncUpdateSlinky(target);
    }, 50);
};

(function() {
    var data = null;
    var $data = null;
    var loaded = false;
    var current_target = null;

    function loadSlinky() {
        if(!loaded) {
            loaded = true;
            $('#drilldown-menu').html($data);
            $('#drilldown-menu').slinky({
                title: false,
            });
        }
    }

    function afterNewMobileMenuReceived() {
        var updating = false;

        fncUpdateSlinky = function (target) {
            if(target == null && current_target != null) {
                return;
            }
            updating = true;
            $data = $(data);
            if (target != null) {
                current_target = target;
                $data.find('.active').removeClass('active');
                $data.find(target).addClass('active');
            }
            var depth = $data.find(target).parents('ul').length * 100;


            $('#drilldown-menu a').click(function () {
                if ($(this).is('.back')) {
                }
                else if ($(this).is('.next')) {
                }
                else {
                    $('#menu-toggle2').click();
                }
            })

            loaded = false;
            if($("#wrapper").hasClass("toggled2") || target != null) {
                loadSlinky();
            }
        }

        setTimeout(function () {
            if (!updating) {
                fncUpdateSlinky(null);
            }
        }, 150)

    }

    AddPageSwapTriggerSwup(function () {
        current_target = null;
        // resetLoaderToMenu(null);
        $.get(document.location.pathname + '?menu=1&json=1', function (obj) {
            data = obj.menu;

            afterNewMobileMenuReceived();
        }, "json");
    });

    $(document).ready(function () {
        fncUpdateSlinky(null);
        whenJsonIsPreloaded('menu', function (json_data) {
            var object = JSON.parse(json_data);
            data = object.menu;

            afterNewMobileMenuReceived();
            // setTimeout(afterNewMobileMenuReceived, 5000);
        });
    });

    AddPageSwapTrigger(function () {

        $('#drilldown-merken-menu').slinky({
            title: false,
        });

        $('.menu-toggle2').unbind('click.slinky');
        $('.menu-toggle2').bind('click.slinky', function() {
            if($(this).is('.shop_m_categorie')) return true;
            loadSlinky();
        });

    });

})();
